const meetsScopePermissionThreshold = (
  scopedPl: number,
  inRoomPl: number,
  isRoomManager: boolean,
  threshold: number
): boolean => scopedPl >= threshold || inRoomPl >= threshold || isRoomManager;

/** True when workspace chat PL, in-room PL, or room-manager status meets a chat-scope permission threshold. */
export const meetsChatPermissionThreshold = (
  scopedChatPl: number,
  inRoomPl: number,
  isRoomManager: boolean,
  threshold: number
): boolean => meetsScopePermissionThreshold(scopedChatPl, inRoomPl, isRoomManager, threshold);

/** True when workspace meeting PL, in-room PL, or room-manager status meets a meeting-scope permission threshold. */
export const meetsMeetingPermissionThreshold = (
  scopedMeetingPl: number,
  inRoomPl: number,
  isRoomManager: boolean,
  threshold: number
): boolean => meetsScopePermissionThreshold(scopedMeetingPl, inRoomPl, isRoomManager, threshold);
